import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Select, MenuItem, FormControl } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Label from 'components/_utility/Label';
import { getProvinces } from 'src/redux/app/selectors';
import ArrowDownIcon from 'src/assets/icons/arrow-down.svg';
import { SelectorContainer, SelectorLabel } from './ProvinceSelector.styled';

const useStyles = makeStyles({
  formControl: {
    border: '1px solid #000',
    borderRadius: '0',
    backgroundColor: '#fff',
  },
  select: {
    '& .MuiSelect-select': {
      padding: '12px 16px',
      fontSize: '14px',
      lineHeight: '20px',
      color: '#2a2a2a',
      backgroundColor: 'transparent',
      border: 'none',
      borderRadius: '0',
      '&:focus': {
        borderRadius: '0',
        backgroundColor: 'transparent',
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& .MuiSelect-icon': {
      display: 'none',
    },
  },
  menuPaper: {
    border: '1px solid #000',
    borderTop: 'none',
    borderRadius: '0',
    boxShadow: 'none',
  },
  menuList: {
    padding: '0',
    '& li::before': {
      display: 'none !important',
    },
  },
  menuItem: {
    fontSize: '14px',
    lineHeight: '20px',
    color: '#2a2a2a',
    padding: '12px 16px',
    '&::before': {
      display: 'none !important',
    },
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
    '&.Mui-selected': {
      backgroundColor: '#f0f0f0',
      '&:hover': {
        backgroundColor: '#e0e0e0',
      },
    },
  },
  customArrow: {
    position: 'absolute',
    top: '50%',
    right: '16px',
    transform: 'translateY(-50%)',
    pointerEvents: 'none',
    width: '16px',
    height: '16px',
  },
});

const ProvinceSelector = ({ selectedProvince, onProvinceChange }) => {
  const classes = useStyles();
  const provinces = useSelector(getProvinces);
  const formControlRef = useRef();
  const [selectWidth, setSelectWidth] = useState(null);

  const handleChange = event => {
    const selectedId = event.target.value;
    const selectedProvinceData = provinces.find(province => province.id === selectedId);
    onProvinceChange(selectedProvinceData);
  };

  const handleOpen = () => {
    if (formControlRef.current && !selectWidth) {
      const width = formControlRef.current.offsetWidth;
      setSelectWidth(width);
    }
  };

  return (
    <SelectorContainer>
      <SelectorLabel>
        <Label name="selectYourProvinceLabel" />
      </SelectorLabel>
      <FormControl
        ref={formControlRef}
        fullWidth
        variant="outlined"
        className={classes.formControl}
        style={{ position: 'relative' }}
      >
        <Select
          value={selectedProvince?.id || ''}
          onChange={handleChange}
          onOpen={handleOpen}
          className={classes.select}
          displayEmpty
          native={false}
          MenuProps={{
            classes: {
              paper: classes.menuPaper,
              list: classes.menuList,
            },
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
            getContentAnchorEl: null,
            disablePortal: false,
            PaperProps: {
              style: selectWidth
                ? {
                    width: selectWidth,
                    marginLeft: '-1px',
                    marginTop: '1px',
                    maxHeight: '300px',
                    overflowY: 'auto',
                  }
                : {},
            },
          }}
        >
          <MenuItem value="" className={classes.menuItem}>
            <Label name="provinceDropdownPlaceholder" />
          </MenuItem>
          {provinces.map(province => (
            <MenuItem key={province.id} value={province.id} className={classes.menuItem}>
              {province.name}
            </MenuItem>
          ))}
        </Select>
        <ArrowDownIcon className={classes.customArrow} />
      </FormControl>
    </SelectorContainer>
  );
};

export default ProvinceSelector;
